<div class="account-not-verified-alert">
  <div class="account-not-verified-alert__icon-wrapper">
    <mat-icon>error_outline</mat-icon>
  </div>
  <div class="account-not-verified-alert__content">
    <div class="account-not-verified-alert__title">
      {{ 'account-not-verified.title' | translate }}
    </div>
    <div
      class="account-not-verified-alert__text"
      [innerHTML]="'account-not-verified.text' | translate"></div>
  </div>
</div>

<app-mui-button variant="contained" color="primary" size="large" (click)="onCompleteVerification()">
  {{ 'buttons.complete-verification' | translate }}
</app-mui-button>
